import { useEffect, useRef, useState } from 'react';

import { FieldDefinition } from '../../../../../components/data-importer/fields/FieldDefinitions';
import { FieldMapping, MappingItem } from '../../../../../components/data-importer/fields/FieldMapping';
import { MapFields } from '../../../../../components/data-importer/map-fields';

export const MapStopFields = ({
  id,
  rawData,
  fields,
  externalIdMappingField,
  tasksEnabled,
  addressFields,
  continueIntlId,
  onCompleted,
  onBack,
}: {
  id: string;
  rawData: any[][];
  fields: FieldDefinition[];
  externalIdMappingField?: MappingItem;
  tasksEnabled?: boolean;
  addressFields?: FieldDefinition[];
  continueIntlId?: string;
  onCompleted: (mappedData: FieldMapping) => void;
  onBack: () => void;
}) => {
  const headers = rawData[0];
  const data = rawData.slice(1);

  const [mapping, setMapping] = useState<FieldMapping>(new FieldMapping([], data));

  // This code is used to load the mapping from local storage on first render
  const idRef = useRef(id);
  const fieldsRef = useRef(FieldMapping.sortFields(fields, addressFields));
  const headersRef = useRef(headers);
  const dataRef = useRef(data);

  useEffect(() => {
    const savedMapping = localStorage.getItem(idRef.current);
    if (savedMapping) {
      const mapping = FieldMapping.fromStorage(
        savedMapping,
        fieldsRef.current,
        headersRef.current.map((value, idx) => ({ index: idx, name: value })),
        dataRef.current
      );
      if (externalIdMappingField) {
        mapping.add(externalIdMappingField.field, externalIdMappingField.column);
      }
      setMapping(mapping);
    } else {
      const newMapping = new FieldMapping([], dataRef.current);
      if (externalIdMappingField) {
        newMapping.add(externalIdMappingField.field, externalIdMappingField.column);
      }
      setMapping(newMapping);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array means this effect runs once on mount

  const getMappedDataLength = () => {
    if (!tasksEnabled || !mapping.getById(`external_id`)) {
      return data.length;
    } else {
      return Object.keys(
        mapping.getData().reduce((acc, row) => {
          if (row.external_id) {
            acc[row.external_id] = true;
          }
          return acc;
        }, {} as { id: number; [value: string]: any })
      ).length;
    }
  };

  return (
    <MapFields
      mapping={mapping}
      headers={headers}
      dataLength={getMappedDataLength()}
      fields={fields}
      addressFields={addressFields}
      continueIntlId={continueIntlId}
      setMapping={setMapping}
      onCompleted={onCompleted}
      onBack={onBack}
    />
  );
};
